<template>
  <div>
    <template v-if="currentNode">
      <div>
        <h4 class=" text-info"
            :style="'margin-left: '+((depth-1)*30)+'px;'+'px;padding-bottom:15px;display: inline-block'">
          <span :style="{color: getColor}">{{depthTitle()}} {{currentNode.name}}</span>
        </h4>
        <div class="well well-sm" v-if="currentNode.comment && currentNode.comment.trim().length !== 0 || currentNode.wiki">
          <div class="row" v-if="currentNode.comment && currentNode.comment.trim().length !== 0">
            <label class="col-xs-2">Comment</label>
            <span class="col-xs-10" v-html="replaceNewlines(currentNode.comment)"></span>
          </div>
          <div class="row" v-if="currentNode.wiki">
            <label class="col-xs-2">Wikipedia</label>
            <div class="col-xs-10"  >
              <span v-html="currentNode.wiki.description"></span>
              <span><a :href='currentNode.wiki.url' style='text-decoration:none;' target='_blank'>More...</a></span>
            </div>
          </div>
        </div>

        <div v-for="(document, keyDocument) in currentNode.documents" :key="keyDocument" class="border-bottom" style="padding: 15px 0">
          <div class="row">
            <label class="col-xs-12" ><span class="label label-info">{{documentType(document)}}</span></label>
          </div>
          <div class="row">
            <label class="col-xs-2" >Title</label>
            <span class="col-xs-10" v-html="document.title"></span>
          </div>
          <div class="row" v-if="documentType(document)!== 'News'">
            <label class="col-xs-2">Authors</label>
            <span class="col-xs-10" v-html="document.authors"></span>
          </div>
          <div class="row">
            <label class="col-xs-2">Publication date:</label>
            <span class="col-xs-10"> {{document.dt | moment('Y')}}</span>
          </div>
          <div class="row">
            <label class="col-xs-2">
              <template v-if="documentType(document)=== 'News'"> Provider</template>
              <template v-else>Source</template>
            </label>
            <span class="col-xs-10" v-html="document.source"></span>
          </div>
          <div class="row">
            <label class="col-xs-2">Added to project</label>
            <span class="col-xs-10" > {{document.added | moment('LL')}}</span>
          </div>
          <div class="row">
            <label class="col-xs-2">Abstract</label>
            <span class="col-xs-10"  v-html="document.abstract"></span>
          </div> <br>
          <div v-if="document.technoLockIn && !$user.isOrange() && !$user.isSe()" class="row">
            <label class="col-xs-2">Tech/sci problem(s)</label>
            <span class="col-xs-10" v-html="document.technoLockIn" ></span>
          </div>
          <div class="row" style="margin-top: 15px">
            <label class="col-xs-2">Link</label>
            <div class="col-xs-10">
              <a :href="document.link ? document.link : '/search/reference/' + document.id" target="_blank">

                <template v-if="documentType(document)=== 'News'"> View news</template>
                <template v-else>View full document</template>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>

    <biblio-tree v-for="(node, key) in nodes" :key="key" v-if="node.childs" :currentNode="node"
                 :nodes="node.childs" :depth="depth + 1" :refDepth="refDepth"/>
  </div>
</template>
<script>

export default {
  props: ['nodes', 'currentNode', 'depth', 'print', 'refDepth'],
  name: 'BiblioTree',
  data () {
    return {
      depthLoop: 1
    }
  },
  computed: {
    getColor: function () {
      return this.currentNode.color === '#888888' ? '' : this.currentNode.color
    }
  },
  methods: {
    depthTitle: function () {
      if (typeof this.refDepth[this.depth - 1] === 'undefined') {
        this.refDepth[this.depth - 1] = 1
      } else {
        this.refDepth[this.depth - 1] += 1
        this.refDepth[this.depth] = 0
      }

      let title = ''
      let i = 0

      while (typeof this.refDepth[i] !== 'undefined' && i !== this.depth) {
        title += this.refDepth[i] + '.'
        ++i
      }

      return title
    },
    documentType: function (document) {
      if (!document.type || document.type === 'science') {
        return 'Science'
      } else if (document.type === 'news') {
        return 'News'
      } else if (document.type === 'company') {
        return 'Company'
      } else if (document.type === 'patent') {
        return 'Patent'
      }
    },
    replaceNewlines: function (texte) {
      return texte.replace(/\n/g, '<br>')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/biblio/BiblioTree.vue